import React from 'react'
import styled from 'styled-components'

export default styled(({ className, href, children }) =>
  <a href={href} target='_blank' rel='noreferrer'>{children}</a>
)`

`
